const show = (dept) => {
  const root = dept.closest('[data-pag-cat]');
  const i = dept.dataset.pagDept;
  root.querySelectorAll('[data-pag-dept]').forEach((d) => d.classList.toggle('is-active', d.dataset.pagDept === i));
  root.querySelectorAll('[data-pag-pane]').forEach((p) => p.classList.toggle('is-active', p.dataset.pagPane === i));
};

['pointerover', 'focusin'].forEach((type) =>
  document.addEventListener(type, (e) => {
    const dept = e.target.closest?.('[data-pag-dept]');
    if (dept && !dept.classList.contains('is-active')) show(dept);
  })
);

document.addEventListener('click', (e) => {
  const dept = e.target.closest?.('[data-pag-dept]');
  if (dept && !dept.classList.contains('is-active')) {
    e.preventDefault();
    show(dept);
  }
});
